import { resolveProperties, resolveProperty } from './resolvers/properties.resolver';
import { resolvePropertyGroups, resolvePropertyGroup } from './resolvers/property.group.resolver';

export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('app.admin.properties', {
      url: '/properties',
      component: 'propertyList',
      resolve: {
        properties: resolveProperties()
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.deletedproperties', {
      url: '/properties/deleted',
      component: 'propertyList',
      resolve: {
        properties: resolveProperties(1, 20, 'deleted')
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.property-add', {
      url: '/properties/create',
      component: 'propertySave',
      resolve: {
        title: () => 'Create a Property',
        property: resolveProperty()
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.property-edit', {
      url: '/properties/:property/update',
      component: 'propertySave',
      resolve: {
        title: () => 'Update a Property',
        property: resolveProperty()
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.groups', {
      url: '/groups',
      component: 'propertyGroupList',
      resolve: {
        propertyGroups: resolvePropertyGroups()
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.deletedgroups', {
      url: '/groups/deleted',
      component: 'propertyGroupList',
      resolve: {
        propertyGroups: resolvePropertyGroups(1, 20, 'deleted')
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.group-add', {
      url: '/groups/create',
      component: 'propertyGroupSave',
      resolve: {
        title: () => 'Create a Property',
        properties: resolveProperties(-1)
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.group-edit', {
      url: '/groups/:propertyGroup/update',
      component: 'propertyGroupSave',
      resolve: {
        title: () => 'Update a Property',
        propertyGroup: resolvePropertyGroup(),
        properties: resolveProperties(-1)
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.connect', {
      url: '/connect?:code&:state',
      component: 'paymentConnect',
      resolve: {
        code: [ '$stateParams', ($stateParams) => {
          return $stateParams.code;
        } ],
        id: [ '$stateParams', ($stateParams) => {
          return $stateParams.state;
        } ]
      }
    });
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/property.routes.js